<template>
    <div class="bg-white px2-pc px1-mobile pb-1">
        <div class="backlink mt3-pc">
            <a layout="row" layout-align="start center" @click="$router.push({name: 'admin-settings-age-groups-index'})"><v-icon class="mr-1" color="grey">mdi-chevron-left</v-icon>{{$t('params.back_ags')}}</a>
        </div>
        <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb-2 mt3-pc mt1-mobile">{{isNew ? $t('params.new_ag') : $t('params.edit_ag')}}</div>

        <v-form class="mt5-pc mt3-mobile" layout="column" layout-align="center center" ref="form" v-model="formValid" @submit.prevent="save">
            <div class="width-95-mobile">
                <div class="font-weight-bold mb-2 mt-3">{{$t('ags.min')}} *</div>
                <v-text-field type="number" v-model="ag.min" class="field-width" :rules="[ v => !!v || $t('errors.required') ]"></v-text-field>
                <div class="font-weight-bold mb-2 mt-3">{{$t('ags.max')}} *</div>
                <v-text-field type="number" v-model="ag.max" class="field-width" :rules="[ v => !!v || $t('errors.required') ]"></v-text-field>
            </div>
            <div layout="row" layout-align="end center" class="field-width width-95-mobile">
                <v-btn depressed color="secondary" @click="save" style="text-transform: none">{{$t('_.save')}}</v-btn>
                &nbsp;{{$t('_.or')}}&nbsp;
                <router-link :to="{name: 'admin-settings-age-groups-index'}" class="grey--text">{{$t('_.cancel')}}</router-link>
            </div>
        </v-form>
    </div>
</template>

<script>
    import Params from '@/api/params'

    export default {
        data () {
            return {
                ag: {
                    id: null,
                    min: null,
                    max: null
                },
                formValid: false,
            }
        },
        mounted () {
            if (!this.isNew) {
                this.fetch();
            }
        },
        methods: {
            fetch () {
                Params.get('age-groups', this.$route.params.id).then(res => {
                    this.ag = res.data;
                })
            },
            save () {
                if (!this.$refs.form.validate()) {
                    return;
                }

                if (this.isNew) {
                    Params.create('age-groups', this.ag).then(() => {
                        this.$router.push({name: 'admin-settings-age-groups-index'});
                        this.$snotify.success(this.$t('params.ag_created'));
                    })
                } else {
                    Params.update('age-groups', this.ag.id, this.ag).then(() => {
                        this.$router.push({name: 'admin-settings-age-groups-index'});
                        this.$snotify.success(this.$t('params.ag_edited'));
                    })
                }
            },
        },
        computed: {
            isNew () {
                return this.$route.params.id === 'new';
            },
        }
    }
</script>